/** Extracts a real http(s) URL when preview openUrl strings embed it (e.g. after .../editor/https%3A%2F%2F...). */
export function normalizeRcsPreviewActionUrl(raw: string): string {
  const s = raw.trim();
  if (!s) return s;

  const lower = s.toLowerCase();
  const encodedStarts = ['https%3a%2f%2f', 'http%3a%2f%2f'];
  for (const marker of encodedStarts) {
    const idx = lower.indexOf(marker);
    if (idx >= 0) {
      try {
        return decodeURIComponent(s.slice(idx));
      } catch {
        break;
      }
    }
  }

  const httpsAt = s.lastIndexOf('https://');
  const httpAt = s.lastIndexOf('http://');
  const literalIdx = Math.max(httpsAt, httpAt);
  if (literalIdx > 0) {
    const tail = s.slice(literalIdx).split(/\s/)[0];
    if (/^https?:\/\/.+/i.test(tail)) {
      return tail;
    }
  }

  return s;
}
